export default "__VITE_ASSET__CExe18Y6__"